import type { SeasonalThemeOption } from '@components/branding';

import { unhandledRequest } from './request';

export async function loadSeasonalTheme() {
  const response = await unhandledRequest.get<SeasonalThemeOption>({ url: '/seasonal-theme/' });
  return response?.data;
}
